<!-- confirm follow dialog -->
<p-dialog
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [(visible)]="isShow"
  styleClass="follow-dialog"
>
  <div class="header">
    ログイン／会員登録のご案内
  </div>
  <div class="body">
    <div class="p-col-12 text-group p-d-flex p-ai-center p-jc-center">
      <!-- ui for not loged in -->
      <div class="p-col-11 text-large">
        <h4 class="p-m-0">会員団体のプロフィール詳細や各地域課題の詳細画面を閲覧するには<br>ログイン／会員登録が必要です。</h4>
      </div>
      <div class="button-group p-d-flex p-jc-center">
        <button
          pButton
          type="button"
          label="ログイン"
          class="button-accept"
          (click)="LoginToB211orB212()"
        ></button>
      </div>
      <!-- ui for not loged in -->
      <div class="button-group p-d-flex p-jc-center" >
        <span (click)="moveA201()" class="link-text link-blue pointer">
          会員登録はこちら
        </span>
      </div>
    </div>
  </div>
</p-dialog>
